<template>
  <div class="ts-space-y-1">
    <div>
      <label class="col-form-label">
        {{ $t('invoice.existingProfile') }}
      </label>
      <ts-select-student v-model="model.student_id" />
    </div>
    <div>
      <div class="row form-group">
        <div class="col-md-6">
          <label class="col-form-label">
            {{
              $t('school.academic.operation.profile_mgt.studentProfile.nameKh')
            }}
          </label>
          <div class="row form-group">
            <div class="col-md-6">
              <input
                type="text"
                ref="first_name_kh"
                v-model.trim="model.first_name_kh"
                class="form-control"
                :class="{
                  'is-invalid': errors.has('first_name_kh')
                }"
                :placeholder="
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.firstName'
                  )
                "
              />
              <div class="invalid-feedback" v-if="errors.has('first_name_kh')">
                {{ errors.first('first_name_kh') }}
              </div>
            </div>
            <div class="col-md-6">
              <input
                type="text"
                v-model.trim="model.last_name_kh"
                class="form-control"
                :class="{
                  'is-invalid': errors.has('last_name_kh')
                }"
                :placeholder="
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.lastName'
                  )
                "
              />
              <div class="invalid-feedback" v-if="errors.has('last_name_kh')">
                {{ errors.first('last_name_kh') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <input
                type="text"
                class="form-control"
                readonly
                :value="fullNameKh"
                :placeholder="
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.fullNameKh'
                  )
                "
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <label
            class="col-form-label"
            :class="{ required: !model.student_id }"
          >
            {{
              $t('school.academic.operation.profile_mgt.studentProfile.nameEn')
            }}
          </label>
          <div class="row form-group">
            <div class="col-md-6">
              <input
                type="text"
                v-model.trim="model.first_name_en"
                class="form-control"
                :class="{
                  'is-invalid': errors.has('first_name_en')
                }"
                :placeholder="
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.firstName'
                  )
                "
              />
              <div class="invalid-feedback" v-if="errors.has('first_name_en')">
                {{ errors.first('first_name_en') }}
              </div>
            </div>
            <div class="col-md-6">
              <input
                type="text"
                v-model.trim="model.last_name_en"
                class="form-control"
                :class="{
                  'is-invalid': errors.has('last_name_en')
                }"
                :placeholder="
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.lastName'
                  )
                "
              />
              <div class="invalid-feedback" v-if="errors.has('last_name_en')">
                {{ errors.first('last_name_en') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <input
                type="text"
                class="form-control"
                readonly
                :value="fullNameEn"
                :placeholder="
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.fullNameEn'
                  )
                "
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <label class="col-md-12 col-form-label required">
          {{
            $t('school.academic.operation.profile_mgt.studentProfile.gender')
          }}
        </label>
        <div class="col-md-12">
          <div class="radio radio-css radio-inline">
            <input
              type="radio"
              id="male"
              v-model="model.gender"
              value="Male"
              :class="{
                'is-invalid': errors.has('gender')
              }"
            />
            <label for="male">Male</label>
          </div>
          <div class="radio radio-css radio-inline">
            <input
              type="radio"
              id="female"
              v-model="model.gender"
              value="Female"
              :class="{
                'is-invalid': errors.has('gender')
              }"
            />
            <label for="female">Female</label>
          </div>
          <div class="ts-text-red-600" v-if="errors.has('gender')">
            {{ errors.first('gender') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import TsSelectStudent from '@/components/SelectStudent'
export default {
  name: 'studentProfileForNoEnroll',
  props: ['value', 'validate'],
  components: {
    TsSelectStudent
  },
  data() {
    return {
      model: {},
      errors: new Errors()
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    fullNameEn() {
      return this.model.last_name_en + ' ' + this.model.first_name_en
    },
    fullNameKh() {
      return this.model.last_name_kh + ' ' + this.model.first_name_kh
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
